import React from 'react';
import './Usuarios.css';
import { Navigate } from 'react-router-dom';
import Header from '../Header/Header';
import UsuariosData from '../../Components/Admin/UsuariosData/UsuariosData';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import useAuthUser from '../../Components/useAuthUser';
import Spiner from '../../Components/Admin/Spiner/Spiner';

export default function Usuarios() {
    const { isAdmin, loading } = useAuthUser();

    if (loading) return <Spiner />;
    if (!isAdmin) return <Navigate to="/dashboard" replace />;
    return (
        <div className='containerGrid'>
            <Header />



            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <UsuariosData />
                </div>
            </section>
        </div>
    )
}
